import { Check, Copy } from 'lucide-react';
import { useState } from 'react';

import { buttonClass } from './ui';

export function CopyButton({
  label,
  onCopy,
  text,
}: {
  label: string;
  onCopy?: () => void;
  text: string;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <>
      <button
        className={buttonClass('secondary', 'sm')}
        onClick={() => {
          void navigator.clipboard.writeText(text).then(() => {
            onCopy?.();
            setCopied(true);
            window.setTimeout(() => setCopied(false), 2000);
          });
        }}
        type="button"
      >
        {copied ? (
          <Check aria-hidden size={16} />
        ) : (
          <Copy aria-hidden size={16} />
        )}
        {copied ? 'Copied' : label}
      </button>
      <span aria-live="polite" className="sr-only">
        {copied ? 'Copied to clipboard' : ''}
      </span>
    </>
  );
}
